import { useLayoutEffect } from 'react';
import {
  AUTO_FONT_SIZE_MIN_EM,
  AUTO_FONT_SIZE_MAX_EM,
  AUTO_FONT_SIZE_MAX_EM_CURRENT,
} from '../utils/scheduleFontSize';

export function fitEmFontSize(element, maxEm, minEm = AUTO_FONT_SIZE_MIN_EM) {
  if (!element) {
    return minEm;
  }

  element.style.whiteSpace = 'nowrap';
  element.style.overflow = 'hidden';

  let low = minEm;
  let high = maxEm;
  let best = minEm;

  for (let i = 0; i < 12; i += 1) {
    const mid = (low + high) / 2;
    element.style.fontSize = `${mid}em`;

    if (element.scrollWidth > element.clientWidth) {
      high = mid;
    } else {
      best = mid;
      low = mid;
    }
  }

  element.style.fontSize = `${best}em`;
  return best;
}

export function useFitEmFontSize(ref, { enabled, text, isCurrent }) {
  const maxEm = isCurrent ? AUTO_FONT_SIZE_MAX_EM_CURRENT : AUTO_FONT_SIZE_MAX_EM;

  useLayoutEffect(() => {
    if (!enabled || !ref.current) {
      return undefined;
    }

    const element = ref.current;

    const measure = () => {
      fitEmFontSize(element, maxEm);
    };

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    if (element.parentElement) {
      observer.observe(element.parentElement);
    }

    return () => observer.disconnect();
  }, [enabled, text, isCurrent, maxEm]);
}
